<!-- TODO: Remove c-table--hoverable when table is empty -->
<table class="u-border-0">
  <ng-content select="colgroup"></ng-content>
  <ng-content select="thead"></ng-content>
  <ng-content select="tbody" *ngIf="!loading"></ng-content>
  <tbody *ngIf="loading">
    <tr>
      <td cass="c-card__content u-state-loading" [attr.colspan]="cols">
        <div class="u-state-loading">
          <div class="c-loader">
            <img src="assets/img/icons/icon-spinner-gray.svg" />
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
